








import { Component, Vue } from 'vue-property-decorator';
import { Endpoints } from '@/ts/store/Constants';
import { saveAs } from 'file-saver';
import axios from 'axios';

@Component
export default class HococoDownloadButton extends Vue {
    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get buttonClasses() {
        return {
            'hococo-inactive': (this.$store.getters['Documents/downloadFilesActive'] === false),
        };
    }

    public downloadPdf() {
        if (this.$store.getters['Documents/downloadFilesActive'] === false) {
            return;
        }

        axios.get(Endpoints.Documents.DOCUMENT_DOWNLOAD_ZIP, { responseType: 'blob' })
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/zip;charset=utf-8',
                });

                saveAs(blob, 'Documents-' + this.$moment().format('YYYY-MM-DD') + '.zip');
        });
    }
}
